export const ALL_PERIODS = ['yesterday', 'this-week', 'last-week', 'this-month', 'last-month', 'custom'] as const;

export type Period = (typeof ALL_PERIODS)[number];

export type PreDefinedPeriod = Exclude<Period, 'custom'>;

export type DateRange = { from: Date; to: Date };

export type DateQuery = Date | null | undefined;
